import React from 'react';
import { Link } from 'react-router-dom';
import LinkManager from '../../lib/LinkManager';
import MentalApi from '../../lib/MentalApi';

type Props = {
    showBackToHome?: boolean,
    showMentalIndexLink?: boolean,
    title: string,
    message: React.ReactNode,
};

export default ({
    showMentalIndexLink,
    title,
    message,
}: Props) => {
    const isLoggedIn = Boolean(MentalApi.getUserData());
    const showLoginHint = !isLoggedIn;

    const loginLink = LinkManager.getLoginLink();
    const indexLink = LinkManager.getMentalIndexLink();

    return (
        <div className="content_inner">
            <div className="title_outer title_without_animation" data-height="120">
                <div className="title title_size_large  position_center " style={{ height: '120px' }}>
                    <div className="image not_responsive" />
                    <div className="title_holder" style={{ paddingTop: '0', height: '120px' }}>
                        <div className="container">
                            <div className="container_inner clearfix">
                                <div className="title_subtitle_holder">
                                    <h1><span>{title}</span></h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="container_inner default_template_holder">
                    <div className="page_not_found">
                        {message}
                        <div className="separator transparent center" style={{ marginTop: '35px' }} />
                        {showLoginHint && (
                            <p>
                                Das liegt vielleicht daran, dass du nicht eingeloggt bist.
                                Falls du bereits registriert bist, gelangst du&nbsp;
                                <a href={loginLink}>HIER ZUM LOGIN</a>
                                .
                            </p>
                        )}
                        {showMentalIndexLink && (
                            <p>
                                Zur den Mentals gelangst du&nbsp;
                                <Link to={indexLink}>HIER</Link>
                            </p>
                        )}
                        <div className="separator transparent center" style={{ marginTop: '35px' }} />
                    </div>
                </div>
            </div>
        </div>
    );
};
